import { defineMessages } from 'react-intl';

export const DateTime = defineMessages({
  date: {
    id: 'app.common.date',
    defaultMessage: 'Datum',
  },
  time: {
    id: 'app.common.time',
    defaultMessage: 'Čas',
  },
  now: {
    id: 'app.common.now',
    defaultMessage: 'Nyní',
  },
});

export const OldValuesStepContent = defineMessages({
  title: {
    id: 'app.InstallationTechnologyStepContent.title',
    defaultMessage: 'Identifikované měřidlo',
  },
  strapiId: {
    id: 'app.common.strapiId',
    defaultMessage: 'StrapiId',
  },
  sn: {
    id: 'app.common.sn',
    defaultMessage: 'SN',
  },
  replacementDateAndTimeLabel: {
    id: 'app.common.replacementDateAndTimeLabel',
    defaultMessage: 'Datum a čas výměny',
  },
  replacementDateAndTimeRequired: {
    id: 'app.common.replacementDateAndTimeRequired',
    defaultMessage: 'Musíš zadat datum a čas výměny',
  },
  oldMeterSerialNumberLabel: {
    id: 'app.common.oldMeterSerialNumberLabel',
    defaultMessage: 'Sériové číslo starého měřidla',
  },
});

export const OldValuesStepFooter = defineMessages({
  next: {
    id: 'app.common.next',
    defaultMessage: 'Další',
  },
});
